import { toConsumableArray as _toConsumableArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { Children, useEffect } from 'react';
import { IoTicketOutline } from '@react-icons/all-files/io5/IoTicketOutline';
import { EditorPlaceholder } from '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import { useCouponContext } from '../../contexts/external/CouponContext.js';
import { useEditorInfoContext } from '../../contexts/external/EditorInfoContext.js';
import 'lodash-es';
import '@bucketplace/ui';
import 'use-context-selector';
import { useEditorNode } from '../../hooks/useEditorNode.js';
import 'qs';
import 'query-string';
import '@bucketplace/bucket-log';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Coupon(props) {
  var cartCouponMoldId = props.id,
    _props$productCouponM = props.productCouponMoldId,
    productCouponMoldId = _props$productCouponM === void 0 ? '' : _props$productCouponM,
    children = props.children,
    path = props.path,
    canChildFocus = props.canChildFocus,
    logData = props.logData;
  var _useEditorNode = useEditorNode([].concat(_toConsumableArray(path), [0])),
    displayMode = _useEditorNode.displayMode,
    onSelect = _useEditorNode.onSelect;
  var _useCouponContext = useCouponContext(),
    onClick = _useCouponContext.onClick;
  var _useEditorInfoContext = useEditorInfoContext(),
    onSendLog = _useEditorInfoContext.onSendLog;
  var hasChildren = Children.count(children) > 0;
  useEffect(function () {
    if (canChildFocus) {
      onSelect();
    }
  }, [canChildFocus]);
  if (!hasChildren) {
    return jsx(EditorPlaceholder, {
      icon: jsx(IoTicketOutline, null),
      message: "\uCFE0\uD3F0\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
    });
  }
  var handleCouponClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(displayMode === 'edit')) {
              _context.next = 3;
              break;
            }
            alert("\uCFE0\uD3F0 \uC544\uC774\uB514: ".concat(cartCouponMoldId, " ").concat(productCouponMoldId, " \n\uC5D0\uB514\uD130\uC5D0\uC11C\uB294 \uCFE0\uD3F0\uC744 \uB2E4\uC6B4\uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."));
            return _context.abrupt("return");
          case 3:
            if (logData) {
              onSendLog === null || onSendLog === void 0 || onSendLog(logData);
            }
            _context.next = 6;
            return onClick === null || onClick === void 0 ? void 0 : onClick(cartCouponMoldId.replace(/ /g, '').split(','), productCouponMoldId.replace(/ /g, '').split(','));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCouponClick() {
      return _ref.apply(this, arguments);
    };
  }();
  return jsx(CouponWrapper, {
    onClick: handleCouponClick
  }, children);
}
var CouponWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ukdzbw0"
} : {
  target: "e1ukdzbw0",
  label: "CouponWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "e0dnmk",
  styles: "cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvdXBvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBcUVnQyIsImZpbGUiOiJDb3Vwb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENoaWxkcmVuLCBQcm9wc1dpdGhDaGlsZHJlbiwgUmVhY3RFbGVtZW50LCB1c2VFZmZlY3QgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBJb1RpY2tldE91dGxpbmUgfSBmcm9tICdAcmVhY3QtaWNvbnMvYWxsLWZpbGVzL2lvNS9Jb1RpY2tldE91dGxpbmUnO1xuaW1wb3J0IHsgQnVja2V0TG9nRGF0YSB9IGZyb20gJ0BidWNrZXRwbGFjZS9idWNrZXQtbG9nJztcblxuaW1wb3J0IHsgRWRpdG9yUGxhY2Vob2xkZXIgfSBmcm9tICcuLi8uLi9jb21wb25lbnRzL0VkaXRvclBsYWNlaG9sZGVyJztcbmltcG9ydCB7IHVzZUVkaXRvckluZm9Db250ZXh0IH0gZnJvbSAnLi4vLi4vY29udGV4dHMnO1xuaW1wb3J0IHsgdXNlQ291cG9uQ29udGV4dCB9IGZyb20gJy4uLy4uL2NvbnRleHRzJztcbmltcG9ydCB7IHVzZUVkaXRvck5vZGUgfSBmcm9tICcuLi8uLi9ob29rcyc7XG5pbXBvcnQgeyBEb2N1bWVudFBhdGggfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCB0eXBlIENvdXBvblRoZW1lcyA9ICd0aGVtZS0xJyB8ICdjdXN0b20nO1xuZXhwb3J0IGludGVyZmFjZSBDb3Vwb25Qcm9wcyB7XG4gIC8qKiDsnqXrsJTqtazri4gg7L+g7Y+w7YuAIGlk65OkICovXG4gIGlkOiBzdHJpbmc7XG4gIC8qKiDsg4Htkojsv6Dtj7Dti4AgaWTrk6QgKi9cbiAgcHJvZHVjdENvdXBvbk1vbGRJZD86IHN0cmluZztcbiAgLyoqIOy/oO2PsO2LgCDsobDtmowg7ZuEIGZvY3Vz66W8IGNoaWxkcmVu7Jy866GcIOuzgOqyve2VmOq4sCDsnITtlbQg7IKs7JqpICovXG4gIGNhbkNoaWxkRm9jdXM/OiBib29sZWFuO1xuICBwYXRoOiBEb2N1bWVudFBhdGg7XG4gIGxvZ0RhdGE/OiBCdWNrZXRMb2dEYXRhO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gQ291cG9uKHByb3BzOiBQcm9wc1dpdGhDaGlsZHJlbjxDb3Vwb25Qcm9wcz4pOiBSZWFjdEVsZW1lbnQge1xuICBjb25zdCB7IGlkOiBjYXJ0Q291cG9uTW9sZElkLCBwcm9kdWN0Q291cG9uTW9sZElkID0gJycsIGNoaWxkcmVuLCBwYXRoLCBjYW5DaGlsZEZvY3VzLCBsb2dEYXRhIH0gPSBwcm9wcztcblxuICBjb25zdCB7IGRpc3BsYXlNb2RlLCBvblNlbGVjdCB9ID0gdXNlRWRpdG9yTm9kZShbLi4ucGF0aCwgMF0pO1xuICBjb25zdCB7IG9uQ2xpY2sgfSA9IHVzZUNvdXBvbkNvbnRleHQoKTtcbiAgY29uc3QgeyBvblNlbmRMb2cgfSA9IHVzZUVkaXRvckluZm9Db250ZXh0KCk7XG5cbiAgY29uc3QgaGFzQ2hpbGRyZW4gPSBDaGlsZHJlbi5jb3VudChjaGlsZHJlbikgPiAwO1xuXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaWYgKGNhbkNoaWxkRm9jdXMpIHtcbiAgICAgIG9uU2VsZWN0KCk7XG4gICAgfVxuICB9LCBbY2FuQ2hpbGRGb2N1c10pO1xuXG4gIGlmICghaGFzQ2hpbGRyZW4pIHtcbiAgICByZXR1cm4gKFxuICAgICAgPEVkaXRvclBsYWNlaG9sZGVyXG4gICAgICAgIGljb249ezxJb1RpY2tldE91dGxpbmUgLz59XG4gICAgICAgIG1lc3NhZ2U9XCLsv6Dtj7DsnYQg7LaU6rCA7ZW07KO87IS47JqULlwiXG4gICAgICAvPlxuICAgICk7XG4gIH1cblxuICBjb25zdCBoYW5kbGVDb3Vwb25DbGljayA9IGFzeW5jICgpOiBQcm9taXNlPHZvaWQ+ID0+IHtcbiAgICBpZiAoZGlzcGxheU1vZGUgPT09ICdlZGl0Jykge1xuICAgICAgYWxlcnQoYOy/oO2PsCDslYTsnbTrlJQ6ICR7Y2FydENvdXBvbk1vbGRJZH0gJHtwcm9kdWN0Q291cG9uTW9sZElkfSBcXG7sl5DrlJTthLDsl5DshJzripQg7L+g7Y+w7J2EIOuLpOyatOuhnOuTnO2VoCDsiJgg7JeG7Iq164uI64ukLmApO1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGlmIChsb2dEYXRhKSB7XG4gICAgICBvblNlbmRMb2c/Lihsb2dEYXRhKTtcbiAgICB9XG4gICAgYXdhaXQgb25DbGljaz8uKFxuICAgICAgY2FydENvdXBvbk1vbGRJZC5yZXBsYWNlKC8gL2csICcnKS5zcGxpdCgnLCcpLFxuICAgICAgcHJvZHVjdENvdXBvbk1vbGRJZC5yZXBsYWNlKC8gL2csICcnKS5zcGxpdCgnLCcpLFxuICAgICk7XG4gIH07XG5cbiAgcmV0dXJuIChcbiAgICA8Q291cG9uV3JhcHBlciBvbkNsaWNrPXtoYW5kbGVDb3Vwb25DbGlja30+XG4gICAgICB7IGNoaWxkcmVuIH1cbiAgICA8L0NvdXBvbldyYXBwZXI+XG4gICk7XG59XG5cbmNvbnN0IENvdXBvbldyYXBwZXIgPSBzdHlsZWQuZGl2YFxuICBjdXJzb3I6IHBvaW50ZXI7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { Coupon };
//# sourceMappingURL=Coupon.js.map
